export default __webpack_public_path__ + "static/media/mime.704c16c9.png";